import { useState, useMemo } from 'react'
import DeepAnalysisContextCard from './DeepAnalysisContextCard'
import DeepAnalysisResultSection from './DeepAnalysisResultSection'
import DeepAnalysisSlotsContext from '../../StateManagment/DeepAnalysisSlotsContext'

/**
 * Context card + "Resultaat" section for the research and activity
 * deep-analysis pages. Needed because the effect page's slots are filled by
 * QuestionData only; the research and activity charts (ResearchData,
 * OutputData, the event-field charts) show their details through
 * CardHeaderInfoPopover, which would otherwise render them inside the result
 * card. Here the context card's facts pane is offered as the details slot.
 *
 * The slot provider wraps only the result section, so other sections on the
 * page (e.g. 'Onderzoeken samenvoegen') keep their details in their own card.
 *
 * @param {object} props
 * @param {string} props.aboutTitle - Heading of the about pane, e.g. 'Over dit onderzoek'
 * @param {string} [props.aboutText] - Description of the anchor entity; pane is hidden when empty
 * @param {string} props.description - Explainer under the "Gemeten resultaat" title
 * @param {React.ReactNode} props.children - The analysis card (with a passthrough frame)
 */
const DeepAnalysisResultWithContext = ({ aboutTitle, aboutText, description, children }) => {
    const [detailsEl, setDetailsEl] = useState(/** @type {HTMLElement|null} */ (null))
    // Second details pane for the compare period (see slotsForSide).
    // AI-CONTEXT: See docs/features/deep-analysis-period.md
    const [detailsElB, setDetailsElB] = useState(/** @type {HTMLElement|null} */ (null))

    const slots = useMemo(
        () => ({
            factsEl: null,
            participationEl: null,
            detailsEl,
            B: { factsEl: null, participationEl: null, detailsEl: detailsElB },
        }),
        [detailsEl, detailsElB]
    )

    return (
        <>
            <DeepAnalysisContextCard
                aboutTitle={aboutTitle}
                aboutText={aboutText}
                setFactsEl={setDetailsEl}
                setFactsElB={setDetailsElB}
            />
            <DeepAnalysisSlotsContext.Provider value={slots}>
                <DeepAnalysisResultSection description={description}>
                    {children}
                </DeepAnalysisResultSection>
            </DeepAnalysisSlotsContext.Provider>
        </>
    )
}

export default DeepAnalysisResultWithContext
